/// <amd-module name="Build/Common/Commands/newfolder/Command.types" />
import { DefinitionReference, Folder } from "Build/Client/Contracts/Build";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface INewFolderState {
    name: string;
    description: string;
    nameErrorMessage: string;
}

export interface INewFolderProps extends IVssComponentProperties {
    pageContext: IVssPageContext;
    projectId: string;
    parentPath: string;
    onClose: () => any;
    onFolderCreated?: (folder: Folder) => any;
}
